/* eslint no-undef: 0 */
/* eslint arrow-parens: 0 */
import React from 'react';
import { enquireScreen } from 'enquire-js';
import Nav2 from '../../Home/Nav2';
import Footer2 from '../../Home/Footer2';
import Contact from './Contact';
// import ChangePassword from './ChangePassword'; 

import {
  Nav20DataSource,
} from '../../Home/data.source';

import '../../Home/less/antMotionStyle.less';

let isMobile;
enquireScreen((b) => {
  isMobile = b;
});

export default class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobile,
    };
  }

  componentDidMount() {
    // 适配手机屏幕;
    enquireScreen((b) => {
      this.setState({ isMobile: !!b });
    });
  }

  render() {
    const children = [
      <Nav2
        id="Nav2_0"
        key="Nav2_0"
        dataSource={Nav20DataSource}
        isMobile={this.state.isMobile}
      />,
      <Contact/>,
      <Footer2
        id="Footer2_0"
        key="Footer2_0"
        isMobile={this.state.isMobile}
       />, // 导航和页尾不进入锚点区，如果需要，自行添加;
    ];
    return (
      <div
        className="templates-wrapper"
        ref={(d) => {
          this.dom = d;
        }}
      > 
        {children}
      </div>
    );
  }
}
